(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

module.exports = function () {

    var WidgetIncludesFunctions = {
        queryParams: {},
        frameId: null
    };

    /** @see https://css-tricks.com/snippets/javascript/get-url-variables/ */
    WidgetIncludesFunctions.getQueryVariable = function (param) {
        if (!WidgetIncludesFunctions.queryParams.length) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                WidgetIncludesFunctions.queryParams[pair[0]] = pair[1];
            }
        }

        var paramVal = null;
        $.each(WidgetIncludesFunctions.queryParams, function (index, value) {
            if (index === param) {
                paramVal = value;
                return false;
            }
        });

        return paramVal;
    };

    /**
     * Sends out a message, which will be listened to by the parent 
     * window, which contains info to size the widget iframe
     *
     * @author JWK
     * @return {void}
     */
    WidgetIncludesFunctions.broadcastDimensions = function () {
        if (!WidgetIncludesFunctions.frameId) {
            WidgetIncludesFunctions.frameId = WidgetIncludesFunctions.getQueryVariable('frameId');
        }

        parent.window.postMessage(JSON.stringify({
            frameId: WidgetIncludesFunctions.frameId,
            height: $('body').outerHeight()
        }), '*');
    };

    WidgetIncludesFunctions.widgetSetAdvocateId = function (advocateid) {
        if (advocateid !== undefined) {
            window.advocateid = advocateid;

            $('.webintent-sharebtn').each(function () {
                //If advocateid isn't in the URL, add it
                var link = $(this).attr('href');
                //If advocateid is already set as a url param, this will result in duplicate URL params, but thats ok; the PHP will choose the latest one, which is the one we want it to look at.
                $(this).attr('href', link + '&advocateid=' + advocateid);
            });
        }
    };

    WidgetIncludesFunctions.widgetSerializeToObject = function (formdataserialized) {
        var formdata = {};
        var formdataserialized = $('#action-container form').serializeArray();
        $.each(formdataserialized, function () {
            if (formdata[this.name] !== undefined) {
                if (!formdata[this.name].push) {
                    formdata[this.name] = [formdata[this.name]];
                }
                formdata[this.name].push(this.value || '');
            } else {
                formdata[this.name] = this.value || '';
            }
        });

        return formdata;
    };

    WidgetIncludesFunctions.widgetPageCompleted = function () {
        WidgetIncludesFunctions.widgetHideErrorMessage();
        $('#submitloadingcontainer').hide();

        $('.share-container').hide(400);
        $('#action-form').hide(400);
        $('#completed-container').show(400);

        setTimeout(WidgetIncludesFunctions.broadcastDimensions, 500);
    };

    WidgetIncludesFunctions.widgetShowErrorMessage = function (errormessage) {

        if ($('#action-container .errorcontainer').length <= 0) {
            var message = '<div class="alert alert-danger" style="display: none;">';
            message += '<strong>' + window.P2A.WidgetParams.transUhOh + '</strong> ' + errormessage;
            message += '</div>';

            $('#action-container #heading').after(message);

            $('#action-container .errorcontainer').show();
        } else {
            $('#action-container .errorcontainer').html('<div class="alert alert-danger"><strong>' + window.P2A.WidgetParams.transUhOh + '</strong> ' + errormessage + "</div>");
        }

        WidgetIncludesFunctions.broadcastDimensions();

        $('html, body').animate({
            scrollTop: $('#action-container .errorcontainer').offset().top
        }, 400);
    };

    WidgetIncludesFunctions.widgetHideErrorMessage = function () {
        $('#action-container .errorcontainer').hide();
    };

    WidgetIncludesFunctions.init = function () {

        $(function () {

            var $submitButton = $('#submitbutton');

            WidgetIncludesFunctions.broadcastDimensions();

            if (window.P2A.WidgetParams.errorMessage) {
                WidgetIncludesFunctions.widgetShowErrorMessage(window.P2A.WidgetParams.errorMessage);
            }
            $('#action-container').keydown(function (e) {
                //If user presses enter, don't do normal form functionality, use our functionality
                var code = e.keyCode || e.which;

                if (code == 13 && $(document.activeElement).prop("tagName").toLowerCase() != 'textarea') {
                    //Hide mobile keyboard
                    $(document.activeElement).blur();

                    //Find out which button to trigger
                    $('#action-container .actionsubmitbutton').each(function () {
                        if ($(this).is(':visible')) {
                            $(this).trigger('click');
                            return false;
                        } else {
                            return true; //continue
                        }
                    });

                    e.preventDefault();
                    return false;
                }
            });

            //Ovverride for AJAX submit
            $submitButton.show();

            $submitButton.click(function () {

                //Serialize the data and then transform it into an object
                //This allows us to get ALL the fields, plus add a few of our own
                var formData = WidgetIncludesFunctions.widgetSerializeToObject($('#action-container form').serializeArray());

                formData.noredirect = 1;

                $submitButton.hide();
                $('#submitloadingcontainer').show();

                if (typeof window.P2A.WidgetParams.campaignUrl !== 'undefined') {
                    $.ajax({
                        type: 'post',
                        url: window.P2A.WidgetParams.campaignUrl,
                        dataType: 'json',
                        data: formData,
                        success: function success(returndata) {
                            //If there an is an error message, show it and don't mark action as completed
                            if (returndata.error.length) {

                                $('#submitbutton').show();
                                $('#submitloadingcontainer').hide();

                                WidgetIncludesFunctions.widgetShowErrorMessage(returndata.error);
                                return false;
                            } else if (returndata.success == '1') {

                                $.event.trigger({
                                    type: "action",
                                    message: 'acq'
                                });

                                //Mark the page as completed
                                WidgetIncludesFunctions.widgetPageCompleted();

                                WidgetIncludesFunctions.widgetSetAdvocateId(returndata.advocateid);

                                return false;
                            }
                        },
                        error: function error(xhr, status, _error) {
                            if (status === 'timeout') {
                                //The php will still run in the background, but when it returns, it won't do anything to conflict with what we are doing now
                                //Mark the page as completed
                                WidgetIncludesFunctions.widgetPageCompleted();
                            }
                        },
                        timeout: 15000
                    });
                    return false;
                }
            });
        });
    };

    $(document).on('widgetFormEvent scorecardEvent', function (e, params) {
        WidgetIncludesFunctions.broadcastDimensions();
    });

    $(document).on('widgetFormEvent lookup-complete', function (e, params) {
        WidgetIncludesFunctions.broadcastDimensions();
    });

    return WidgetIncludesFunctions;
};

},{}],2:[function(require,module,exports){
'use strict';

(function () {
  var WidgetIncludesFunctions = require('./_widgetincludesfunctions.js')();
  WidgetIncludesFunctions.init();
})();

},{"./_widgetincludesfunctions.js":1}]},{},[2]);
